"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Helpers = require("helpers");
var Order = /** @class */ (function (_super) {
    __extends(Order, _super);
    function Order() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Order.prototype.render = function () {
        var _a = this.props, order = _a.order, onClick = _a.onClick;
        return (React.createElement("div", { className: "flex flex-col w-full border border-fleece-dark px-2-4 pt-2-4 pb-1-2 my-1-6 text-charcoal text-xs" },
            React.createElement("div", { className: "flex justify-between pb-2-4" },
                React.createElement("div", { className: "flex flex-col" },
                    React.createElement("div", { className: "text-xmd text-navy-dark pb-0-3" },
                        "Order",
                        order.name),
                    React.createElement("div", { className: "" },
                        "Placed:",
                        next_components_1.ShopifyNext.Utils.formatDate(order.created_at, "HH:mm DD/MM/YYYY"))),
                React.createElement("div", { className: "" }, "Track Delivery")),
            React.createElement("div", { className: "flex row justify-between pb-2-4" },
                React.createElement("div", { className: "w-6/13" },
                    React.createElement("div", { className: "border-b border-charcoal-light text-sm text-midnight font-medium uppercase tracking-wide leading-loose mb-1-9" }, "Delivery Details"),
                    order.shipping_address ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "pb-0-6" },
                            React.createElement("div", { className: "pb-0-3" }, order.shipping_address.name),
                            React.createElement("div", { className: "pb-0-3" }, order.email),
                            React.createElement("div", { className: "pb-0-3" }, order.shipping_address.phone)),
                        React.createElement("div", { className: "pb-0-6" },
                            React.createElement("div", { className: "pb-0-3" }, order.shipping_address.address1),
                            React.createElement("div", { className: "pb-0-3" },
                                order.shipping_address.city,
                                ",",
                                order.shipping_address.zip),
                            React.createElement("div", { className: "pb-0-3" }, order.shipping_address.province)))) : (React.createElement("p", null, "\u2013"))),
                React.createElement("div", { className: "w-6/13" },
                    React.createElement("div", { className: "border-b border-charcoal-light text-sm text-midnight font-medium uppercase tracking-wide leading-loose mb-1-9" }, "Billing Details"),
                    order.billing_address ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "pb-0-6" },
                            React.createElement("div", { className: "pb-0-3" }, order.billing_address.name),
                            React.createElement("div", { className: "pb-0-3" }, order.email),
                            React.createElement("div", { className: "pb-0-3" }, order.billing_address.phone)),
                        React.createElement("div", { className: "pb-0-6" },
                            React.createElement("div", { className: "pb-0-3" }, order.billing_address.address1),
                            React.createElement("div", { className: "pb-0-3" },
                                order.billing_address.city,
                                ",",
                                order.billing_address.zip),
                            React.createElement("div", { className: "pb-0-3" }, order.billing_address.province)))) : (React.createElement("p", null, "\u2013")))),
            React.createElement("div", { className: "flex flex-col pb-2-4" },
                React.createElement("div", { className: "border-b border-charcoal-light text-sm text-midnight font-medium uppercase tracking-wide leading-loose mb-1-9" }, "Order Details"),
                React.createElement("div", null, order.line_items.map(function (line_item, i) {
                    if (line_item.selected_variant === 0) {
                        return (React.createElement("div", { key: i, className: "pb-0-6" }, "This product is not available anymore"));
                    }
                    return (React.createElement("div", { key: line_item.id, className: "flex" },
                        React.createElement("div", null,
                            React.createElement("img", { src: line_item.product.images && line_item.product.images.length
                                    ? Helpers.imageUrl(line_item.product.images[0].src, 112)
                                    : null, alt: line_item.product.images && line_item.product.images.length ? line_item.product.images[0].alt : null })),
                        React.createElement("div", { className: "flex flex-col flex-auto px-1-6" },
                            React.createElement("div", { className: "text-sm font-medium text-midnight pb-0-6" }, line_item.title),
                            line_item.product.options.map(function (option, index) { return (React.createElement("div", { key: option.position },
                                option.name,
                                ":",
                                line_item.variant["option" + index])); })),
                        React.createElement("div", null, "$ " + line_item.price)));
                }))),
            React.createElement("div", { className: "flex flex-col pb-2-4" },
                React.createElement("div", { className: "border-b border-charcoal-light text-sm text-midnight font-medium uppercase tracking-wide leading-loose mb-1-9" }, "Summary"),
                React.createElement("div", null,
                    React.createElement("div", { className: "flex justify-between pb-0-3" },
                        React.createElement("div", null, "Order Subtotal"),
                        React.createElement("div", null, "$ " + order.subtotal_price / 100)),
                    order.shipping_methods && order.shipping_methods.length ? (React.createElement("div", { className: "flex justify-between pb-0-3" },
                        React.createElement("div", null, "Delivery"),
                        React.createElement("div", null, order.shipping_methods.map(function (method) { return (React.createElement(React.Fragment, null, "$ " + method.price / 100)); })))) : null,
                    React.createElement("div", { className: "flex justify-between pb-0-3" },
                        React.createElement("div", null, "Total Inc. GST"),
                        React.createElement("div", null, "$ " + order.total_price / 100)),
                    order.transactions[0].payment_details.credit_card_company && (React.createElement("div", { className: "flex justify-between pb-0-3" },
                        React.createElement("div", null, "Payment Method"),
                        React.createElement("div", null, order.transactions[0].payment_details.credit_card_company))))),
            React.createElement("div", { className: (this.props.onClick ? "flex" : "hidden") + " justify-center border-t border-fleece-mid pt-1-2 text-xs" },
                React.createElement("button", { onClick: onClick }, "Hide Order Details"))));
    };
    Order.contextType = next_components_1.ShopifyNext.Context;
    return Order;
}(React.Component));
exports.Order = Order;
